<div [innerHTML]="notification.data.localizedText[currentUser.locale]"></div>
